import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { useAppStorage } from '~/config/useConfigStorage'

export default defineNuxtPlugin(async () => {
  const { storageFP, storageCkSetting } = useAppStorage()

  if (storageCkSetting.value.analytics) {
    if (storageFP.value) return useDPrint('指纹已初始化', storageFP.value)
    useDPrint('开始初始化指纹')
    const fp = await FingerprintJS.load()
    const { visitorId } = await fp.get()
    useDPrint('完成指纹初始化', visitorId)
    storageFP.value = visitorId
  } else {
    useDPrint('用户未开启网站分析')
  }
})
